module.exports = __webpack_public_path__ + "static/media/penalty-taker.dda9c87b.svg";